/**
 * Fairyglim-Fix (v2 - eigener Dateiname wegen CDN-Cache):
 * uebertraegt Werte aus Globo-Product-Options-Feldern (die
 * ausserhalb des Warenkorb-Formulars liegen) als korrekte
 * line item properties in den Add-to-Cart-Request.
 *
 * Grund: Im Dawn-Theme liegt <form data-type="add-to-cart-form">
 * nur innerhalb des buy-buttons-Snippets. App-Bloecke wie Globo
 * Product Options werden als Geschwister-Elemente ausserhalb
 * dieses Formulars gerendert; ihre Eingaben werden dadurch beim
 * Absenden nicht automatisch mitgeschickt.
 */
(function () {
  function injectGloboProperties(form) {
    var fields = document.querySelectorAll('.gpo-app input, .gpo-app textarea, .gpo-app select');
    fields.forEach(function (field) {
      if (!field.name) return;

      var existing = form.querySelector(
        'input[data-gpo-mirror="' + CSS.escape(field.name) + '"]'
      );
      if (existing) existing.remove();

      var hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'properties[' + field.name + ']';
      hidden.value = field.value || '';
      hidden.setAttribute('data-gpo-mirror', field.name);
      form.appendChild(hidden);
    });
  }

  // Capture-Phase: laeuft garantiert VOR Dawns eigenem submit-Handler
  // (product-form.js), der die FormData aus dem Formular baut.
  document.addEventListener(
    'submit',
    function (evt) {
      var form = evt.target;
      if (form && form.matches && form.matches('form[data-type="add-to-cart-form"]')) {
        injectGloboProperties(form);
      }
    },
    true
  );
})();
